import { Field } from "../Field/field";
import { ModulesManagerService } from "../Module/modules-manager.service";

export class PhoneNumberField extends Field {    
    constructor(manager : ModulesManagerService,Data= null){
        super(manager,Data)
    }  
}
